let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gc0SB")).then(() => parcelRequire('gk2H8'));